import client from "./client";

export interface Photo {
  id: number;
  userId: number;
  templateId: number;
  questionTxt: string;
  url: string;
  description: string;
  /** Encoded PhotoLayout string (see components/PhotoPage/photoPresets.ts).
   *  Legacy values: "top" | "center" | "bottom" | "vertical" | "square" | "horizontal" */
  position: string;
  showDate: boolean;
  showDescription: boolean;
  /** Дата, проставленная на странице книги (yyyy-mm-dd, postgres date type).
   *  Может быть null, если юзер ничего не задавал — PDF тогда падает на
   *  createdAt. */
  date: string | null;
  createdAt: string;
}

export const photosApi = {
  getByTemplate: (templateId: number) =>
    client.get<Photo[]>(`/photos/${templateId}`),

  create: (data: {
    templateId: number;
    url: string;
    description?: string;
    position?: string;
    questionTxt?: string;
    /** yyyy-mm-dd; null/undefined → бэк не пишет в date. */
    date?: string | null;
    /** Не передали — бэк сам погасит показ даты, если date пустая. */
    showDate?: boolean;
    showDescription?: boolean;
  }) => client.post<Photo>("/photos", data),

  update: (id: number, data: Partial<Photo>) =>
    client.patch<Photo>(`/photos/${id}`, data),

  remove: (id: number) =>
    client.delete(`/photos/${id}`),
};
